/// <reference path="../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługuje panel nawigacyjny strony
 *
 * @export
 * @class Navi
 */

export class Navi {
	constructor(options) {
		var noop = function () { };
		var defaults = {
			navi: null,
			btnMenuMobile: null,
			naviSearchBar: null,
			navMobile: null,
			onMobileMenuBtnClick: noop,
			onChangeNaviToMobileView: noop,
			onChangeNaviToDesktopView: noop,
			navMobileLvl: 0,
			initNavLvl: 1, // 1 oznacza wyswietlenie pierwszego poziomu na otwarcie menu (0 - "kategorie")

		};
		this.settings = $.extend({}, defaults, options);
		this.actualNaviState = null;
		this.mobileNaviOpened = false;
		this.isStucked = false;

		this.menu2023_currWidth = $(window).width();
		this.menu2023_resizeControlTimer = null;
	}
	// ****************************************************************************************************
	// Inicjalizacja panelu search
	// ****************************************************************************************************
	init() {
		var that = this;

		if ( NAV2023 && $("#navMobile.navMobile2023").length > 0 ){
			that.init2023();
		} else {
			that.settings.navi = $('#navi');
			if (that.settings.navi.length > 0) {
				that.settings.btnMenuMobile = $('#btnMenuMobile');
				that.settings.naviSearchBar = $('#naviSearchBar');
				that.settings.navMobile = $('#navMobile');
				if (pageObj.settings.bootstrap.kind == 'mobile')
					this.changeNaviToMobileView();
				else
					this.changeNaviToDesktopView();
			}
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja panelu search
	// ****************************************************************************************************
	init2023() {
		var that = this;

		$("#navMobile.navMobile2023 .mainMenuSubCat").each(function(i,e){
			$(e).on('click', function(event){
				event.stopPropagation();
				if ( $(e).hasClass("more") ) {
					// martwy kod... nigdy sie nie wykoywał
					// if ( $("#navMobile.navMobile2023 .mainMenuSubCatL"+that.settings.navMobileLvl+".active").length > 0 ) {
					// 	$("#navMobile.navMobile2023 .mainMenuSubCatL"+that.settings.navMobileLvl+".active").removeClass("active");
					// }

					that.settings.navMobileLvl = Number( $(e).data("show-lvl") );

					$(e).toggleClass("active");

					$(".subMenuOpened").removeClass("subMenuOpened").scrollTop(0);
					$(e).children("ul").first().addClass("subMenuOpened")

					$("#navMobile.navMobile2023 #navBtnBack").removeClass("hidden");
				}
			});
		});

		$('.initNavBtnBack').on('click', function (event) {
			$('#navBtnBack').trigger('click');
		});

		$("#navMobile.navMobile2023 #navBtnBack").on('click', function(event){
			event.stopPropagation();

			$(".subMenuOpened").removeClass("subMenuOpened").scrollTop(0);
			that.settings.navMobileLvl = that.settings.navMobileLvl - 1;
			if ( that.settings.navMobileLvl == 1 ) {
				$("#navMobile.navMobile2023 .mainMenuGroupL"+that.settings.navMobileLvl).addClass("subMenuOpened");

			} else {
				$("#navMobile.navMobile2023 .mainMenuSubCatL"+(that.settings.navMobileLvl - 1)+".active .mainMenuGroupL"+that.settings.navMobileLvl).addClass("subMenuOpened");

			}

			if ( that.settings.navMobileLvl <= that.settings.initNavLvl ) {
				that.settings.navMobileLvl = that.settings.initNavLvl;

				$("#navMobile.navMobile2023 #navBtnBack").addClass("d-none");
				setTimeout(() => {
					$("#navMobile.navMobile2023 #navBtnBack").removeClass("d-none").addClass("hidden");
				}, 200);;
			} else {
			}

			$("#navMobile.navMobile2023 .mainMenuSubCatL"+that.settings.navMobileLvl+".active").removeClass("active");
		});

		$("#navMobile.navMobile2023 .mainMenuGroup").on('click', function(event){
			event.stopPropagation();
		});


		$("#navMobileMask").on('click', function(event){
			that.settings.navMobileLvl = that.settings.initNavLvl;

			$("#navMobile.navMobile2023 .mainMenuSubCat.active").removeClass("active");
			$("#navMobile.navMobile2023 #navBtnBack").addClass("hidden");

			that.settings.navMobile.collapse('hide');

		});

		$('#loginMobileMenu').on('click', function (event) {
			$('#navBtnToggle').trigger('click');
			setTimeout(function(){
				$('#loginMobile').trigger('click');
			}, 400);
		});

// to standard, jak nic nie zmienie to wykasować
		that.settings.navi = $('#navi');
		if (that.settings.navi.length > 0) {
			that.settings.btnMenuMobile = $('#btnMenuMobile');
			that.settings.naviSearchBar = $('#naviSearchBar');
			that.settings.navMobile = $('#navMobile');

			that.settings.navMobile.on('show.bs.collapse', function () {
				$("body").addClass("scrollBlocked");
			}).on('hide.bs.collapse', function () {
				$("body").removeClass("scrollBlocked");

				$(".subMenuOpened").removeClass("subMenuOpened").scrollTop(0);
				$(".mainMenuGroupL1").addClass("subMenuOpened").scrollTop(0);
			});

			if (pageObj.settings.bootstrap.kind == 'mobile')
				this.changeNaviToMobileView();
			else
				this.changeNaviToDesktopView();
		}
	}
	// ****************************************************************************************************
	// Aktualizujaca panelu search względem bootstrapSize
	// ****************************************************************************************************
	update() {
		var that = this;
		if (pageObj.settings.bootstrap.kind == 'mobile' && this.actualNaviState == 'desktop')
			this.changeNaviToMobileView();
		else if (pageObj.settings.bootstrap.kind == 'desktop' && this.actualNaviState == 'mobile')
			this.changeNaviToDesktopView();
	}
	// ****************************************************************************************************
	// Przełączenie/aktualizacja panelu search w tryp MOBILE
	// ****************************************************************************************************
	changeNaviToMobileView() {
		var that = this;
		that.actualNaviState = 'mobile';

		if ( NAV2023 ) {
			that.settings.naviSearchBar.appendTo('#searchMobile2023');

			$('#changeLanguageContainer').removeClass('d-none'); // .prependTo('#menuHeader')

			$('#accountMobileMenu').on('click', function (event) {
				$('#navBtnToggle').trigger('click');
			});

			$('#mainPageMenu').on('click', function (event) {
				var url = window.location.href.split(".com/")[1];

				if ( url.includes('?') ) {
					url = url.split("?")[0];
				}

				if ( url.includes('#') ) {
					url = url.split("#")[0];
				}

				$('#navBtnToggle').trigger('click');
				if ( url == "" ) {
					event.preventDefault();
				}
			});
		} else {
			that.settings.naviSearchBar.appendTo('#naviRow').hide();
		}

		that.settings.btnMenuMobile.on('click', function (event) {
			that.settings.onMobileMenuBtnClick.call();
		});
		that.settings.navMobile.on('show.bs.collapse', function () {
			that.settings.navi.css('max-height', function () {
				return pageObj.settings.device.initialHeight + 'px';
			});
			that.settings.navi.addClass('overflowX'); // pozwala skrolowac navi gdy jest za duzo elementow
			that.mobileNaviOpened = true;
			that.settings.btnMenuMobile.addClass('active'); // poswietlenie dla mobile gdy otwarte menu
		}).on('hide.bs.collapse', function () {
			that.settings.navi.css('max-height', 'auto');
			that.settings.navi.removeClass('overflowX');
			that.mobileNaviOpened = false;
			that.settings.btnMenuMobile.removeClass('active'); // usuniecie: poswietlenie dla mobile gdy otwarte menu
		});
		$('.toggleBtnNavi').removeClass('btn-sm');
		$('.toggleImgNavi').css('height', function () {
			return $(this).data('mobile-h');
		});
		$('.toggleInputNavi').removeClass('form-control-sm');
		that.settings.onChangeNaviToMobileView.call();
	}
	// ****************************************************************************************************
	// Przełączenie/aktualizacja panelu search w tryp DESKTOP
	// ****************************************************************************************************
	changeNaviToDesktopView() {
		var that = this;
		that.actualNaviState = 'desktop';

		if ( NAV2023 ) {
			$('#mainMenuBtn').on('click', function (event) {
				$('#navBtnToggle').trigger('click');
			});
		}

		that.settings.naviSearchBar.appendTo('#searchDesktop').show();
		$('#changeLanguageContainer').addClass('d-none'); // .appendTo('#navi')

		$('.toggleBtnNavi').addClass('btn-sm');
		$('.toggleImgNavi').css('height', function () {
			return $(this).data('desktop-h');
		});
		$('.toggleInputNavi').addClass('form-control-sm');
		that.settings.onChangeNaviToDesktopView.call();
	}
	// ****************************************************************************************************
	// Wymuszenie zamkniecia otwartego menu w MOBILE
	// ****************************************************************************************************
	hideMobileNavi() {
		var that = this;
		if (that.mobileNaviOpened && that.actualNaviState == 'mobile') {
			that.settings.btnMenuMobile.trigger('click');
		}
	}
}